// src/layouts/PublicLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

// No Context Providers are needed here because:
// - ThemeProvider is provided globally in App.jsx
// - AuthProvider is provided globally in App.jsx
// - SettingsProvider and VersionProvider are specific to AppLayout
// - AppLoadingIndicator logic is specific to AppLayout

// Optional: You could add a minimal wrapper div or fragment if needed for styling,
// or potentially a public-specific header/footer that shouldn't appear in the app.
// For now, it just renders the matched route component.

const PublicLayout = () => {
  return (
    <>
      {" "}
      {/* Using a Fragment, or you could use a div if needed */}
      <Outlet /> {/* This will render PublicLandingPage, Login, Plans, etc. */}
    </>
  );
};

export default PublicLayout;
